
import * as React from 'react';
import { IDefaultClickActionHandler, IDefaultClickActionHandlerProps } from '../DefaultClickAction';
import { Facet } from '../../../../models/Facet';
import { IItemCache } from '../../../../models/IItemCacheObserver';
import { ItemOpenAction } from '../../open/OpenAction';
import { folderFacet } from '../../../../facets/ItemFacets';
import { isGroupFacet } from '../../../../facets/GroupFacets';

export const openDefaultClickActionHandler: IDefaultClickActionHandler = {
    key: new Facet('openDefaultClickHandler').id,
    evaluate: (itemCache: IItemCache, props: IDefaultClickActionHandlerProps) => {
        const {
            itemKey
        } = props;

        const action = itemCache.demandItemFacet(folderFacet, itemKey) ||
            itemCache.demandItemFacet(isGroupFacet, itemKey) ?
            (
                <ItemOpenAction itemKey={ itemKey } />
            ) :
            undefined;

        return {
            action: action
        };
    }
};
